import { render, staticRenderFns } from "./PublicationsForm.vue?vue&type=template&id=2f908b5a&scoped=true&"
import script from "./PublicationsForm.vue?vue&type=script&lang=js&"
export * from "./PublicationsForm.vue?vue&type=script&lang=js&"
import style0 from "./PublicationsForm.vue?vue&type=style&index=0&id=2f908b5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f908b5a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VCheckbox,VCol,VRow,VSelect,VSkeletonLoader})
